// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"266":"c87e6ebd","453":"9428adb1"}[chunkId] + ".chunk.js";
};